import { useState, useEffect } from "react";
import swal from 'sweetalert2';
import * as helper from '../global/helper';
import { postVendorMaster } from "../api/vendorAPI";

const defaultVendor = {
    CancellationHours  : 24,
    MaxWeekdayBookings : 0,
    MaxWeekendBookings : 0,
    Status             : 1,
    Allow9Hole         : 0,
    Allow18Hole        : 1,
};

const AddVendorModal = ({ show, onDismissModal, vendorData, onSave }) => {

    const [vendor, setVendor] = useState(defaultVendor);

    useEffect(() => {
        if (show) {
            setVendor(vendorData ? { ...vendorData } : defaultVendor);
            $('#vendor-add-modal').modal({ backdrop: 'static' });
            $('#vendor-add-modal').on('hidden.bs.modal', function () {
                onDismissModal();
            });
            $('#vendor-add-modal').modal('show');
        } else {
            $('#vendor-add-modal').modal('hide');
        }
    }, [show]);

    const updateVendorDetails = (field, value) => {
        setVendor((d) => ({ ...d, [field]: value }));
    };

    const addVendorHandler = async () => {
        const btn  = $('#btnSave');
        const form = $('#add-vendor-form');

        form.validate({
            rules: {
                txtVendorName         : { required: true },
                txtSlug               : { required: true },
                txtEmail              : { required: true, email: true },
                txtPhone              : { required: true, minlength: 10, maxlength: 15, digits: true },
                txtMaxWeekdayBookings : { required: true, digits: true, min: 0 },
                txtMaxWeekendBookings : { required: true, digits: true, min: 0 },
                txtCancellationHours  : { required: true, digits: true, min: 0 },
            },
            messages: {
                txtVendorName         : { required: "Please enter vendor name" },
                txtSlug               : { required: "Please enter invoice slug" },
                txtEmail              : { required: "Please enter email", email: "Please enter a valid email" },
                txtPhone              : { required: "Please enter phone number", minlength: "Minimum 10 digits required", digits: "Only digits allowed" },
                txtMaxWeekdayBookings : { required: "Please enter max weekday bookings", digits: "Only digits allowed" },
                txtMaxWeekendBookings : { required: "Please enter max weekend bookings", digits: "Only digits allowed" },
                txtCancellationHours  : { required: "Please enter cancellation hours", digits: "Only digits allowed" },
            },
        });

        if (!form.valid()) return;
        helper.StartProcessing(btn);

        if (!vendor.Allow18Hole && !vendor.Allow9Hole) {
            swal.fire({
                icon              : 'warning',
                titleText         : 'Aleast one is required',
                showConfirmButton : false,
                timer             : 1500,
            });
            helper.StopProcessing(btn);
            return;
        }

        const isEdit = !!vendor.ID;

        try {
            const vendorPayload = {
                ID                 : vendor.ID || 0,
                VendorName         : vendor.VendorName,
                Slug               : (vendor.Slug || '').trim().toUpperCase(),
                Email              : vendor.Email,
                Phone              : vendor.Phone,
                MaxWeekdayBookings : vendor.MaxWeekdayBookings || 0,
                MaxWeekendBookings : vendor.MaxWeekendBookings || 0,
                Allow9Hole         : vendor.Allow9Hole,
                Allow18Hole        : vendor.Allow18Hole,
                CancellationHours  : vendor.CancellationHours || 0,
                Status             : vendor.Status,
            };

            await postVendorMaster(vendorPayload);
            helper.StopProcessing(btn);
            onDismissModal();
            onSave(isEdit);

            if (isEdit) {
                swal.fire({
                    toast             : true,
                    icon              : 'success',
                    titleText         : 'Partner updated successfully!',
                    position          : 'bottom-end',
                    showConfirmButton : false,
                    timer             : 1500,
                    animation         : false,
                    customClass       : { popup: 'margin-20' },
                });
            } else {
                swal.fire({
                    icon              : 'success',
                    titleText         : 'Partner added successfully!',
                    showConfirmButton : false,
                    timer             : 1500,
                });
            }
        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon               : 'error',
                titleText          : 'Error!',
                text               : err.message,
                buttonsStyling     : false,
                confirmButtonClass : 'btn btn-brand',
            });
        }
    };

    return (
        <div className="modal fade" id="vendor-add-modal" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{vendor.ID ? 'Edit Partner' : 'Add Partner'}</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form className="kt-form" id="add-vendor-form">
                            <div className="kt-form kt-form--label-right padding-10" role="form">

                                <div className="form-group row">
                                    <label className="col-form-label col-lg-2">Partner Name <span className="red">*</span></label>
                                    <div className="col-lg-5">
                                        <input
                                            id="txtVendorName"
                                            name="txtVendorName"
                                            type="text"
                                            className="form-control"
                                            value={vendor.VendorName || ''}
                                            onChange={(e) => updateVendorDetails('VendorName', e.target.value)}
                                        />
                                    </div>
                                    <label className="col-form-label col-lg-2">Slug  <span className="red">*</span></label>
                                    <div className="col-lg-3">
                                        <input
                                            id="txtSlug"
                                            name="txtSlug"
                                            type="text"
                                            maxLength={16}
                                            className="form-control text-uppercase"
                                            placeholder="e.g KLGR"
                                            value={vendor.Slug || ''}
                                            onChange={(e) => updateVendorDetails('Slug', e.target.value.toUpperCase())}
                                        />
                                        <span className="form-text text-danger pl-1" style={{ fontSize: 12 }}>Invoice prefix</span>
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-form-label col-lg-2">Email <span className="red">*</span></label>
                                    <div className="col-lg-5">
                                        <input
                                            id="txtEmail"
                                            name="txtEmail"
                                            type="text"
                                            className="form-control"
                                            value={vendor.Email || ''}
                                            onChange={(e) => updateVendorDetails('Email', e.target.value)}
                                        />
                                    </div>
                                    <label className="col-form-label col-lg-2">Phone <span className="red">*</span></label>
                                    <div className="col-lg-3">
                                        <input
                                            id="txtPhone"
                                            name="txtPhone"
                                            type="text"
                                            className="form-control"
                                            value={vendor.Phone || ''}
                                            onChange={(e) => updateVendorDetails('Phone', e.target.value)}
                                        />
                                    </div>
                                </div>

                                <hr />

                                <div className="form-group row">
                                    <label className="col-form-label col-lg-2">Cancellation Hours <span className="red">*</span></label>
                                    <div className="col-lg-8">
                                        <input
                                            id="txtCancellationHours"
                                            name="txtCancellationHours"
                                            type="number"
                                            className="form-control"
                                            value={vendor.CancellationHours == 0 ? 0 : vendor.CancellationHours || 24}
                                            onChange={({ target }) => updateVendorDetails('CancellationHours', target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-form-label col-lg-2">Max Weekday Bookings <span className="red">*</span></label>
                                    <div className="col-lg-2">
                                        <input
                                            id="txtMaxWeekdayBookings"
                                            name="txtMaxWeekdayBookings"
                                            type="number"
                                            className="form-control"
                                            value={vendor.MaxWeekdayBookings == 0 ? 0 : vendor.MaxWeekdayBookings || 0}
                                            onChange={({ target }) => updateVendorDetails('MaxWeekdayBookings', target.value)}
                                        />
                                    </div>
                                    <label className="col-form-label col-lg-3">Max Weekend Bookings <span className="red">*</span></label>
                                    <div className="col-lg-2">
                                        <input
                                            id="txtMaxWeekendBookings"
                                            name="txtMaxWeekendBookings"
                                            type="number"
                                            className="form-control"
                                            value={vendor.MaxWeekendBookings == 0 ? 0 : vendor.MaxWeekendBookings || 0}
                                            onChange={({ target }) => updateVendorDetails('MaxWeekendBookings', target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-form-label col-lg-2">Allow 9 Hole</label>
                                    <div className="col-lg-1">
                                        <span className="kt-switch kt-switch--icon">
                                            <label>
                                                <input
                                                    id="chkAllow9Hole"
                                                    name="chkAllow9Hole"
                                                    type="checkbox"
                                                    checked={!!vendor.Allow9Hole}
                                                    onChange={(e) => updateVendorDetails('Allow9Hole', e.target.checked ? 1 : 0)}
                                                />
                                                <span></span>
                                            </label>
                                        </span>
                                    </div>
                                    <label className="col-form-label col-lg-2">Allow 18 Hole</label>
                                    <div className="col-lg-1">
                                        <span className="kt-switch kt-switch--icon">
                                            <label>
                                                <input
                                                    id="chkAllow18Hole"
                                                    name="chkAllow18Hole"
                                                    type="checkbox"
                                                    checked={!!vendor.Allow18Hole}
                                                    onChange={(e) => updateVendorDetails('Allow18Hole', e.target.checked ? 1 : 0)}
                                                />
                                                <span></span>
                                            </label>
                                        </span>
                                    </div>
                                    <label className="col-form-label col-lg-2">Active</label>
                                    <div className="col-lg-1">
                                        <span className="kt-switch kt-switch--icon">
                                            <label>
                                                <input
                                                    id="chkStatus"
                                                    name="chkStatus"
                                                    type="checkbox"
                                                    defaultChecked={vendor.Status}
                                                    onChange={(e) => updateVendorDetails('Status', e.target.checked ? 1 : 0)}
                                                />
                                                <span></span>
                                            </label>
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button>
                        <button id="btnSave" type="button" className="btn btn-brand" onClick={addVendorHandler}>Save</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddVendorModal;
